import {
  SHOW_FORM_MESSAGE,
  HIDE_FORM_MESSAGE,
  GET_FORM,
  GET_FORM_SUCCESS,
  GET_CLIENT_INFO,
  GET_CLIENT_INFO_SUCCESS,
} from '../constants/ActionTypes';

export const getForm = (param) => {
  return {
    type: GET_FORM,
    payload: param,
  };
};

export const getFormSuccess = (param) => {
  return {
    type: GET_FORM_SUCCESS,
    payload: param,
  };
};

export const showMessage = (param) => {
  return {
    type: SHOW_FORM_MESSAGE,
    payload: param,
  };
};

export const hideMessage = (param) => {
  return {
    type: HIDE_FORM_MESSAGE,
    payload: param,
  };
};

export const getClientInfo = (param) => {
  return {
    type: GET_CLIENT_INFO,
    payload: param,
  };
};

export const getClientInfoSuccess = (param) => {
  return {
    type: GET_CLIENT_INFO_SUCCESS,
    payload: param,
  };
};
